import { useContext } from 'react'
import { useSelector } from 'react-redux'
import { ModalContext, ModalKey } from 'components/Modals/ModalContext'
import kinesisLogo from 'media/kinesis_logo.png'

import GroupCompletionLinearFill from 'components/Athlete/v2/AthleteCalendar/AthleteCalendarEventItems/GroupCompletionLinearFill'

export default function PastKinesisWorkoutCalendarEventItem({ eventData }) {

    const { ShowModal } = useContext(ModalContext)

    const profileType = useSelector((state) => state.athleteProfile.profileType)

    const DisplayWorkoutSummaryModal = () => {

        // console.log(eventData.extendedProps)

        const modalData = {
            key: ModalKey.WorkoutSummary,
            size: 'workout-summary',
            calendarDataKey: eventData.extendedProps.calendarDataKey,
            weekOfTheYearKey: eventData.extendedProps.weekOfTheYearKey,
            workoutTemplateKey: eventData.extendedProps.workoutTemplateKey,
            completionData: eventData.extendedProps.completionData
        }

        ShowModal(modalData)

    }

    if (profileType === 'group') {
        return (
            <div 
                // onClick={DisplayWorkoutSummaryModal}
            >
                <div className='flex items-center gap-x-0.5'>
                    <img src={kinesisLogo} alt='Kinesis Logo' className='h-4 w-4' />
                    <div className='text-gray-800 text-xxs 2xl:text-xs font-medium whitespace-normal'>{eventData.title}</div>
                </div>

                <GroupCompletionLinearFill calendarDataKey={'past'} eventData={eventData} />

                {/* <div className='text-center text-gray-500 text-xxs 2xl:text-xs'>View</div> */}
            </div>
        )
    }

    if (profileType === 'group-individual' || profileType === 'individual') {
        return (
            <div 
                onClick={DisplayWorkoutSummaryModal}
            >
                <div className='flex items-center gap-x-0.5'>
                    <img src={kinesisLogo} alt='Kinesis Logo' className='h-4 w-4' />
                    <div className='text-gray-800 text-xxs 2xl:text-xs font-medium whitespace-normal'>{eventData.title}</div>
                </div>

                {eventData.extendedProps.completionData.completed && <div className='pl-0.5 text-green-500 text-xxs 2xl:text-xs'>Complete</div>}

                {!eventData.extendedProps.completionData.completed && <div className='pl-0.5 text-red-500 text-xxs 2xl:text-xs'>Incomplete</div>}
            </div>
        )
    }
}